<app-rotation-warning></app-rotation-warning>
<app-video-call-modal
  *ngIf="callOverlay.getActive$() | async"
  [incomingCall]="(callOverlay.getPayload$() | async)?.incomingCall"
  [calleeUserId]="(callOverlay.getPayload$() | async)?.calleeUserId"
  [patientId]="(callOverlay.getPayload$() | async)?.patientId"
  [callType]="(callOverlay.getPayload$() | async)?.callType"
  [callContextType]="(callOverlay.getPayload$() | async)?.callContextType"
></app-video-call-modal>

<app-toast></app-toast>
<router-outlet></router-outlet>
